function ThankYouPage() {
    return (
        <div>
            <style jsx>
                {`
                    .final_page {
                        width: 75%;
                        padding: 1rem;
                        margin: 6px 0;
                        text-align: center;
                        background-color: #fff;
                        margin-left: auto;
                        margin-right: auto;
                    }
                    .thank-you-heading {
                        font-size: 2rem;
                    }
                    .thank-you-message {
                        color: #1e1e1e;
                        font-size: 14px;
                    }
                    .thank-you-image {
                        display: block;
                        margin: 0;
                        margin-left: auto;
                        margin-right: auto;
                    }
                    @media only screen and (max-width: 600px) {
                        .thank-you-heading {
                            font-size: 1.5rem;
                        }
                        .thank-you-message {
                            font-size: 1rem;
                        }
                    }
                `}
            </style>
            <div className="final_page">
                <img className="thank-you-image" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaWQ9IkxheWVyXzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYxMiA3OTI7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA2MTIgNzkyIiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiM0MUFENDk7fQo8L3N0eWxlPjxnPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01NjIsMzk2YzAtMTQxLjQtMTE0LjYtMjU2LTI1Ni0yNTZTNTAsMjU0LjYsNTAsMzk2czExNC42LDI1NiwyNTYsMjU2UzU2Miw1MzcuNCw1NjIsMzk2TDU2MiwzOTZ6ICAgIE01MDEuNywyOTYuM2wtMjQxLDI0MWwwLDBsLTE3LjIsMTcuMkwxMTAuMyw0MjEuM2w1OC44LTU4LjhsNzQuNSw3NC41bDE5OS40LTE5OS40TDUwMS43LDI5Ni4zTDUwMS43LDI5Ni4zeiIvPjwvZz48L3N2Zz4=" width="90px" alt="Thank you!" />
                <h1 className="thank-you-heading">Thank you!</h1>       
                <p className="thank-you-message">Your form has been submitted successfully!</p>
            </div>
        </div>
    )
}

export default ThankYouPage
